module.exports = __webpack_public_path__ + "img/9788946055599.dafe81ed.jpg";